import { render, staticRenderFns } from "./XiamenUnicom.vue?vue&type=template&id=d10ad4b4&scoped=true"
import script from "./XiamenUnicom.vue?vue&type=script&lang=js"
export * from "./XiamenUnicom.vue?vue&type=script&lang=js"
import style0 from "./XiamenUnicom.vue?vue&type=style&index=0&id=d10ad4b4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d10ad4b4",
  null
  
)

export default component.exports